import dsBridge from 'dsbridge'
import { useUserStore } from '../stores/user'
/**
 * @Description 获取登录信息（H5调用原生）
 * 使用场景：进入H5
 */
function getUserData() {
  // 调用android方法获取用户信息
  const info = useUserStore()
  const str = dsBridge.call('getUserInfo', 'getUserInfo')
  console.log('********str', str)
  if (str) {
    const data = JSON.parse(str)
    info.setNativeInfo(data)
    info.setToken(data?.token || '')
    console.log('********保存原生信息成功')
  } else {
    destroyH5()
  }
}

/**
 * @Description 获取头部信息
 * 使用场景：进入H5
 */
function getHeaderData() {
  // 调用android方法获取用户信息
  const info = useUserStore()
  const str = dsBridge.call('getAppRequestHeader', 'getAppRequestHeader')
  console.log('********str', str)
  if (str) {
    const data = JSON.parse(str)
    info.setHeader(data)
  } else {
    destroyH5()
  }
}

export async function nativeLoad(callback: () => void) {
  dsBridge.register('goRefreshPage', function () {
    callback()
  })
}
/**
 * @Description 获取Version和Platform（H5调用原生）
 */
function getVersionInfo() {
  const userStore = useUserStore()
  const str = dsBridge.call('getAppInfo', 'getAppInfo')
  if (str) {
    const data = JSON.parse(str)
    userStore.setUserInfo(data)
  } else {
    destroyH5()
  }
}

export function toNativePage(data: {
  id: string
  type: 'edit' | 'upload' | 'view'
  code: string
}) {
  dsBridge.call('toNativePage', data)
}

/**
 * @Description token异常（H5调用原生）
 * 使用场景：token异常跳转至app登录页，将异常code传至app
 */
function tokenInvalid(msg: number) {
  dsBridge.call('tokenInvalid', msg + '')
  console.log('通知原生登录token异常')
}

/**
 * @Description 销毁H5页面（H5调用原生）
 * 使用场景：底层页面返回至app、未获取到登录信息等
 */
function destroyH5() {
  console.log('销毁H5')
  dsBridge.call('finish', 'finish')
}

/**
 * @Description 调用相机拍照和选取图片
 * 返回参数：就是扫码返回的值
 */
function getPhoto(params = { size: 4 }) {
  return new Promise((resolve: any) => {
    dsBridge.call('takePhoto', params, function (_res) {
      resolve(_res)
    })
  })
}

/**
 * @Description 拍照
 */
function openCameraTakePhoto(params = { size: 1 }) {
  return new Promise((resolve: any, reject: any) => {
    dsBridge.call('openCameraTakePhoto', params, function (_res) {
      resolve(_res)
    })
  })
}

/**
 * @Description 相册
 */
function openAlbumSelectPhoto(params = { size: 1 }) {
  return new Promise((resolve: any, reject: any) => {
    dsBridge.call('openAlbumSelectPhoto', params, function (_res) {
      resolve(_res)
    })
  })
}
export {
  getUserData,
  getVersionInfo,
  tokenInvalid,
  destroyH5,
  getPhoto,
  openCameraTakePhoto,
  openAlbumSelectPhoto,
  getHeaderData
}
